import { cls } from "@fvilers/cls";
import { CheckIcon } from "@imi/icons/CheckIcon.js";
import { TriangleIcon } from "@imi/icons/TriangleIcon.js";
import { LoadingSpinner } from "@imi/ui/components/LoadingSpinner/LoadingSpinner.js";
import { Tooltip } from "@imi/ui/components/Tooltip/Tooltip.js";
import { TooltipContent } from "@imi/ui/components/Tooltip/TooltipContent.js";
import { TooltipTrigger } from "@imi/ui/components/Tooltip/TooltipTrigger.js";
import { useParseValidationResult } from "@src/core/engine/validationResults/useParseValidationResult";
import { useTranslation } from "react-i18next";
import { BatchSelectionRow } from "../../../store/types";
import styles from "./SuggestionsStatus.module.css";

type SuggestionsStatusProps = {
  row: BatchSelectionRow;
};

export function SuggestionsStatus({ row }: SuggestionsStatusProps) {
  const { t } = useTranslation("product", {
    keyPrefix: "selection.batch.dataTable",
  });
  const parseValidationResult = useParseValidationResult({
    fieldsT: { prefix: "status", t },
    maxDecimals: 3,
  });

  if (row.output?.status === "loading") {
    return <LoadingSpinner className={styles.SuggestionsStatus} />;
  }

  if (row.status?.severity && row.status.severity !== "info") {
    return (
      <Tooltip disabled={row.status.path === "pipeSize"}>
        <TooltipTrigger asChild>
          <div className={styles.SuggestionsStatusWrapper}>
            <TriangleIcon
              className={cls(
                styles.SuggestionsStatus,
                styles[row.status.severity],
              )}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent variant={row.status.severity}>
          {parseValidationResult(row.status)}
        </TooltipContent>
      </Tooltip>
    );
  }

  if (row.status?.severity === "info") {
    return (
      <div className={styles.SuggestionsStatusWrapper}>
        <TriangleIcon
          className={cls(styles.SuggestionsStatus, styles.warning)}
        />
      </div>
    );
  }

  if (row.output?.status === "loaded") {
    return (
      <CheckIcon className={cls(styles.SuggestionsStatus, styles.success)} />
    );
  }

  return null;
}
